<div class="container component-blank">
    <div class="row bg-gradient component-header-size">
      <h1 class="component-header-title">{{ cardTitle.title | uppercase}}</h1>
    </div>
    <div class="row component-body-size">

    </div>
    <button mat-mini-fab class="button-plus" [ngClass]="{'button-check' : button_selected}" (click)="addComponent()"></button>
  </div>
